import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { InfoIcon, Text } from '@beef/ui-kit';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

type ErrorProps = { text: string };

export const Error: FC<ErrorProps> = ({ text }) => (
  <div className={cn('wrap')}>
    <div className={cn('error-icon', 'mar-r-2xs')}>
      <InfoIcon size={16} />
    </div>
    <Text color="grey60" size="size6-r">
      {text}
    </Text>
  </div>
);
